export const getTechList = (data: any): string[] => {
  if (data?.data?.attributes?.techstack_list?.technologies) {
    return data.data.attributes.techstack_list.technologies;
  } else {
    return [];
  }
};
